export function isUndefined(value) {
    return value === undefined;
}
export function assertIsUndefined(value) {
    if (!isUndefined(value)) {
        throw new TypeError(`Value is not undefined.`);
    }
}
export function isNotUndefined(value) {
    return value !== undefined;
}
export function assertIsNotUndefined(value) {
    if (!isNotUndefined(value)) {
        throw new TypeError(`Value is undefined.`);
    }
}
//# sourceMappingURL=undefined.js.map